module.exports = __webpack_public_path__ + "img/pic_5.96bc0b66.png";